import { useEffect, useState } from "react";

const useRegions = (organisation) => {
  const [regions, setRegions] = useState({});

  useEffect(() => {
    if (organisation?.attributes?.Regions) {
      const regions = {};
      organisation?.attributes?.Regions.forEach((item) => {
        if (!regions[item.region_id]) {
          regions[item.region_id] = item;
        }
      });
      setRegions(regions);
    }
  }, [organisation]);

  return regions;
};

export default useRegions;
